export default __webpack_public_path__ + "static/media/card-img-3.ec95ac5e.svg";